import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  orders: {
    width: 100,
    height: 100,
    paths: [
      {
        style: `fill: #4d4d4d`,
        d: `M50.71,12.18,61.16,8a4.89,4.89,0,0,1,6.36,2.71l.6,1.5ZM16.07,26.11l-3.23,1.3a4.89,
        4.89,0,0,0-2.71,6.36l5.94,14.77ZM31.88,87.83l.6,1.49A4.89,4.89,0,0,0,38.84,92l10.45-4.2Zm58-21.6L83.93,
        51.47V73.89l3.23-1.3A4.89,4.89,0,0,0,89.87,66.23Z`,
      },
      {
        style: `fill: #eb212e`,
        d: `M76,15.17H24a4.89,4.89,0,0,0-4.89,4.89V79.94A4.89,4.89,0,0,0,24,84.83H76a4.89,4.89,0,0,0,4.89-4.89V20.06A4.89,
        4.89,0,0,0,76,15.17ZM34.23,69.46a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,34.23,69.46Zm0-11.58a2.1,2.1,0,1,1,2.1-2.09A2.09,
        2.09,0,0,1,34.23,57.88Zm0-11.57a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,34.23,46.31Zm0-11.57a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,
        0,0,1,34.23,34.74ZM58.45,68.07a.79.79,0,0,1-.79.79H40.58a.79.79,0,0,1-.8-.79V66.66a.8.8,0,0,1,.8-.8H57.66a.79.79,0,0,1,
        .79.8Zm9.42-11.58a.8.8,0,0,1-.8.8H40.58a.8.8,0,0,1-.8-.8V55.08a.79.79,0,0,1,.8-.79H67.07a.79.79,0,0,1,.8.79Zm0-11.92a.8.8,
        0,0,1-.8.8H40.58a.8.8,0,0,1-.8-.8V43.16a.79.79,0,0,1,.8-.79H67.07a.79.79,0,0,1,.8.79Zm0-11.23a.8.8,0,0,1-.8.8H40.58a.8.8,0,
        0,1-.8-.8V31.93a.79.79,0,0,1,.8-.79H67.07a.79.79,0,0,1,.8.79Z`,
      },
    ],
  },
});
